import {Component, effect, input, output, signal, untracked} from '@angular/core';
import {TypeChangementDate} from '../model/type-changment-date.model';

@Component({
	selector: 'app-calendrier-header',
	templateUrl: './calendrier-header.component.html',
	styleUrl: './calendrier-header.component.scss'
})
export class CalendrierHeaderComponent {
	dateActuelleCalendrier = input.required<Date>();
	typeChangementDate = input<TypeChangementDate>(TypeChangementDate.MOIS);
	afficherWeekend = input<boolean>(false);

	eventChangerDeDate = output<Date>();

	dateCourante = signal<Date>(new Date());

	constructor() {
		effect(() => {
			const dateActuelle = this.dateActuelleCalendrier();
			untracked(() => this.dateCourante.set(dateActuelle));
		});
	}

	/**
	 * Passe au mois / semaine suivant(e) si la direction est +1 ou au mois / semaine précédent(e) si la direction est -1.
	 * @param direction la direction pour savoir quel mois / semaine récupérer.
	 */
	changerDeMoisOuSemaineAvecFlecheDirectionnelle(direction: number): void {
		const newDate = new Date(this.dateCourante());

		switch (this.typeChangementDate()) {
			case TypeChangementDate.MOIS:
				newDate.setDate(1);
				newDate.setMonth(newDate.getMonth() + direction);
				break;
			case TypeChangementDate.SEMAINE: {
				newDate.setDate(newDate.getDate() + (7 * direction));
				break;
			}
		}

		this.dateCourante.set(newDate);

		this.changerDeDate();
	}

	/**
	 * Change le mois / semaine dans le calendrier.
	 */
	changerDeDate(): void {
		this.eventChangerDeDate.emit(this.dateCourante());
	}

	/**
	 * Renvoie true si la date actuelle du calendrier correspond au mois / semaine courant false sinon.
	 */
	estDateActuelleEgaleMoisSemaineCourant(): boolean {
		if (this.typeChangementDate() === TypeChangementDate.SEMAINE) {
			const dateCourante = this.dateCourante();
			const dateAujourdhui = new Date();

			// Calculer le début et la fin de la semaine courante (lundi à vendredi)
			const premierJourSemaine = new Date(dateAujourdhui);
			premierJourSemaine.setDate(dateAujourdhui.getDate() - ((dateAujourdhui.getDay() + 6) % 7)); // Lundi

			// 0 correspond à dimanche, 4 à vendredi
			const indexDernierJourSemaine = this.afficherWeekend() ? 0 : 4;

			const dernierJourSemaine = new Date(premierJourSemaine);
			dernierJourSemaine.setDate(premierJourSemaine.getDate() + indexDernierJourSemaine);

			return dateCourante >= premierJourSemaine && dateCourante <= dernierJourSemaine;
		}

		return this.dateCourante().getMonth() === new Date().getMonth();
	}

	/**
	 * Récupère les semaines du mois courant.
	 */
	retournerAuMoisOuSemaineCourant(): void {
		const dateCourante = new Date();

		if (this.typeChangementDate() === TypeChangementDate.MOIS) {
			dateCourante.setDate(1);
		}

		this.dateCourante.set(dateCourante);

		this.changerDeDate();
	}

	protected readonly TypeChangementDate = TypeChangementDate;
}
